import React from 'react'
import Header from '../comman/Header'
import Footer from '../comman/Footer'   
import CountUp from 'react-countup';

export const Sponsors = () => {
  return (
    <>
 
<Header/>
  <section className="new_section  position-relative">
    <div
      id="carouselExampleFade"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner carousel-inner2">
        <div className="carousel-item active">
          <img src="img/banner1.jpg" className="d-block w-100" alt="banner" />
        </div>
        <div className="carousel-item">
          <img src="img/banner2.jpg" className="d-block w-100" alt="banner" />
        </div>
      </div>
    </div>
    <div className="banner_content text-center">
      <div className="container">
        <h1>
          SPONSOR<span className="color1"> KIT</span>  
        </h1>
        <h4 className="ttu">Projected Statistics
        </h4>
      
       
        
      </div>
    </div>
  </section>
  <section className="bg_light">
  <div className="container">
    <div className="clockdiv2" id="section_counter">
      <div className="row">
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 0.5s 1 normal forwards running slide-up"
            }}
          >
            <div className="count">
              <CountUp end={50000}  duration={2.75} /> <span>+</span>
            </div>
            <span>Visitors</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 0.75s 1 normal forwards running slide-up"
            }}
          >
            <div className="count" >
               <CountUp end={200}  duration={2.75} /> <span>+</span>
            </div>
            <span>Companies</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 1s 1 normal forwards running slide-up"
            }}
          >
            <div className="count"  >
            <CountUp end={60}  duration={2.75} /> <span>+</span>
            </div>
            <span>Speakers</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 1.25s 1 normal forwards running slide-up"
            }}
          >
            <div className="count" >
            <CountUp end={50}  duration={2.75} /> <span>+</span>
            </div>
            <span>Countries</span>
          </div>
        </div>
      </div>
    </div>
  </div> 

  <section className="hero position-relative p70 pb-0">
    <div className="container">
      <h2 className="hadding ttu text-center mb-md-5">
      Sponsorship  <span className="color1">Program </span> 
      </h2>
 
    <div className="row">
      <div className="col-md-6 mb-4">
        <div className="pricingTable">
          <h3 className="title">Plan 1</h3>
          <div className="price-value">
            <span className="currency">$</span>
            <span className="amount">10.000</span> 
          </div>
          <ul className="pricing-content">
            <li> 1 exhibitor booth </li>
            <li> List of member companies of the World Blockchain Alliance </li>
            <li> Register logo on website and app </li>
            <li> Registration of participating country brochure list (English) </li>
            <li> Place a small logo on meeting schedules and lead capture </li>
            <li> Minimal site branding  </li>
          </ul>
          <a href="#" className="pricingTable-signup">
          Booth Application
          </a>
        </div>
      </div>
      <div className="col-md-6 mb-4 ">
        <div className="pricingTable pink">
          <h3 className="title">Plan 2</h3>
          <div className="price-value">
            <span className="currency">$</span>
            <span className="amount">50,000</span> 
          </div>
          <ul className="pricing-content">
            <li> 1 standalone exhibition booth  </li>
            <li> List of World Blockchain Alliance members Register your logo on websites and apps  </li>
            <li> Register brochure list of participating countries (English)  </li>
            <li>  Place a small logo on your meeting calendar and capture leads.  </li>
            <li> Minimal site branding   </li>
            <li> Basic meeting location provided  </li>
          </ul>
          <a href="#" className="pricingTable-signup">
          Booth application
          </a>
        </div>
      </div>
      <div className="col-md-6 mb-4">
        <div className="pricingTable blue">
          <h3 className="title">Plan 3</h3>
          <div className="price-value">
            <span className="currency">$</span>
            <span className="amount">100.000</span> 
          </div>
          <ul className="pricing-content">
            <li> 1 standalone exhibition booth   </li>
            <li> List of World Blockchain Alliance members Register your logo on websites and apps </li>
            <li> Register brochure list of participating countries (English)  </li>
            <li> Place a small logo on your meeting calendar and capture leads.  </li>
            <li> Minimal site branding   </li>
            <li> Basic meeting location provided  </li>
            <li> Large logo registered on website and app </li>
          </ul>
          <a href="#" className="pricingTable-signup">
          Booth application
          </a>
        </div>
      </div>
      <div className="col-md-6 mb-4">
        <div className="pricingTable blue2">
          <h3 className="title">Plan 4</h3>
          <div className="price-value">
            <span className="currency">$</span>
            <span className="amount">150.000</span> 
          </div>
          <ul className="pricing-content">
            <li> 1 standalone exhibition booth  </li>
            <li> List of World Blockchain Alliance members Register your logo on websites and apps </li>
            <li>Register brochure list of participating countries (English)</li>
            <li> Place a small logo on your meeting calendar and capture leads.   </li>
            <li> Minimal site branding   </li>
            <li> Basic meeting location provided   </li>
            <li> Large logo registered on website and app  </li>
            <li> Announcement form and logo placement for weekly newsletter, media concierge  </li>
            <li> Access to dedicated media access  </li>
          </ul>
          <a href="#" className="pricingTable-signup">
          Booth application
          </a>
        </div>
      </div>
    </div> 
    </div>
  </section>
 
  <section className="position-relative p70">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center "> 
      SPONSORABLE  <span className="color1"> ITEMS</span> 
      </h2>
      <h2 className='text-center'>Exhibitor booths & Meeting Rooms</h2>
      <p className='text-center mb-4 mb-md-5'>Join Expo with standard options, including an impactful booth for product display and a dedicated conference room offering premium<br/> private space for strategic collaboration.</p>
      <div className="row    justify-content-center">
        <div className="col-md-5">
        <div className="item_box">
          <img src="img/items1.jpg" alt="items1" className="img-fluid" />
          <div className="d-flex align-items-center justify-content-between mt-4">
          <h4>Basic Booth </h4>
          <h3 className='color1 fw-semibold'>$5K </h3>
        </div>
        <p>Elevate your brand in a space that is space-efficient yet perfect for powerful new connections.</p>
        </div>
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-5">
        <div className="item_box">
          <img src="img/items2.jpg" alt="items2" className="img-fluid" />
          <div className="d-flex align-items-center justify-content-between mt-4">
          <h4>Woodworking A </h4>
          <h3 className='color1 fw-semibold'>$7K </h3>
        </div>
        <p>Build stylish connections in a simple booth that puts your brand in the spotlight in a conference setting.</p>
        </div>
      </div>
      </div>
    </div>
  </section> </section>


  <section className="position-relative p70 ">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center"> 
      Independent  <span className="color1"> Booth</span>
      </h2>
      <p className='text-center mb-4 mb-md-5'>Share your company's image for product display with the world. Join the expo with options that offer impressive <br/>promotional booths and premium space for strategic planning.</p>
      <div className="row align-items-center">
        <div className="col-lg-6">
          <img src="img/lbi.jpg" alt="Independent" className="img-fluid" />
        </div>
        <div className="col-lg-6">
          <img src="img/rbi.jpg" alt="Independent" className="img-fluid" />
        </div>
      </div>

      <h2 className='color1 fw-semibold'>$20K~</h2>
      <h5>Secure global customers with efficient, powerful, and impressive promotions using the space you need.<br/>
      Increase your brand value in the perfect space to connect with new customers.</h5>
    </div>
  </section> 

  <section className="position-relative p70 bg_light">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center"> 
      Independent  <span className="color1"> Booth</span>
      </h2>
      <p className='text-center mb-4 mb-md-5 h3'>Sponsor Program Special independent booth (entrance, escalator)</p>
      <div className="row  mb-4">
        <div className="col-lg-8">
          <img src="img/ib1.jpg" alt="Independent" className="img-fluid" />
        </div>
        <div className="col-lg-4">
          <img src="img/ib2.jpg" alt="Independent" className="img-fluid" />
        </div>
      </div>

      <h2 className='color1 fw-semibold'>$150K~</h2>
      <h5>Attract global customers with sponsored booth promotions that leverage important entrance and escalator spaces to create strong awareness of your company.<br/>
      Increase your brand value with high-quality products that are perfect for new customers.</h5>
    </div>
  </section> 
  <section className="position-relative p70 ">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center"> 
      The quality of   <span className="color1"> business meetings</span>
      </h2>
      <p className='text-center mb-4   '>Complete the elegance of a unique contract in a special space. You can increase the best investment value.</p>
      <div className=" mb-4 c_images">
      <div className="row m-1">
        <div className="col-md-4 p-1">
          <img src="img/c1.jpg" alt="business" className="img-fluid" />
        </div>
        <div className="col-md-4 p-1">
          <img src="img/c2.jpg" alt="business" className="img-fluid" />
        </div>
        <div className="col-md-4 p-1">
          <img src="img/c3.jpg" alt="business" className="img-fluid" />
        </div>
        <div className="col-md-8 ">
        <div className="row">
        <div className="col-4 p-1">
          <img src="img/c4.jpg" alt="business" className="img-fluid" />
        </div>
        <div className="col-4 p-1">
          <img src="img/c5.jpg" alt="business" className="img-fluid" />
        </div>
        <div className="col-4 p-1">
          <img src="img/c6.jpg" alt="business" className="img-fluid" />
        </div>
        </div>
        </div>
        <div className="col-md-4  p-1">
          <img src="img/c7.jpg" alt="business" className="img-fluid" />
        </div>
        
      </div>
      </div>

      <h2 className='color1 fw-semibold'>$150K~</h2>
      <h5>Attract global customers with sponsored booth promotions that leverage important entrance and escalator spaces to create strong awareness of your company.<br/>
      Increase your brand value with high-quality products that are perfect for new customers.</h5>
    </div>
  </section> 

  <section className="position-relative p70 pb-1 bg_light">
    <div className="container position-relative zindex mb-md-5 pb-5">
      <h2 className="hadding ttu text-center"> 
      On Site   <span className="color1"> Branding</span>
      </h2>
      <p className='text-center mb-4 mb-md-5 h4'>Strengthen your brand awareness through Blockchain World Investment Expo’s on-site branding options. Maximize your company’s visibility with dynamic digital displays and attention-grabbing LED billboards. Choose from a variety of options.</p>
      <div className="row  mb-4">
        <div className="col-md-6">
          <img src="img/brand1.jpg" alt="brand1" className="img-fluid" />
        </div>
        <div className="col-md-6">
          <img src="img/brand2.jpg" alt="brand2" className="img-fluid" />
        </div>
      </div>
      <div className="text-center pt-2">
      <h4 className='mb-3'>Click here to apply for our various sponsorship programs.</h4>
      <a className='btn pe-md-5  ps-md-5' href='#'>Click Now</a>
    </div>
    </div>


  <section className="">
    <div className="container">
      <div className="man_right">
        <div className="row m-0">
          <div className="col-md-5   bg_lrft text-center">
            <div className="f_contat_boc">
              <i className="ii bi bi-geo-alt" />
              <h5>ADDRESS</h5>
              <p>
                South Korea, an East Asian nation on the southern half of the
                Korean Peninsula
              </p>
            </div>
            <div className="f_contat_boc mt-4">
              <i className="ii bi bi-headset" />
              <h5>CONTACT</h5>
              <a className="me-3" href="tel:+919876543210">
                <span>
                  <i className="bi bi-whatsapp" /> +91 9876543210
                </span>
              </a>
              <a href="mailto:info@korea.com">
                <span>
                  <i className="bi bi-envelope" /> info@korea.com
                </span>
              </a>
            </div>
          </div>
          <div className="col-md-7 p-0">
            <iframe
              className="googlemap"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1393252.7503539645!2d126.48437860513499!3d35.79830230636209!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356455ebcb11ba9b%3A0x91249b00ba88db4b!2sSouth%20Korea!5e0!3m2!1sen!2sin!4v1731055189432!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  </section> 
  <Footer/>
</> 
  )
}
